import React from 'react';
import { DirectionToggle } from '../shared/DirectionToggle';
import { DigitKeypad } from '../shared/DigitKeypad';
import { TickSelector } from '../shared/TickSelector';

interface OverUnderParamsProps {
  direction: 'over' | 'under';
  thresholdDigit: number;
  tickCount: number;
  onDirectionChange: (direction: 'over' | 'under') => void;
  onThresholdDigitSelect: (digit: number) => void;
  onTickCountChange: (count: number) => void;
}

const OverUnderParams: React.FC<OverUnderParamsProps> = ({
  direction,
  thresholdDigit,
  tickCount,
  onDirectionChange,
  onThresholdDigitSelect,
  onTickCountChange
}) => {
  return (
    <>
      <div className="parameter-group">
        <label>Direction</label>
        <DirectionToggle
          leftLabel="Over"
          rightLabel="Under"
          selectedDirection={direction}
          onDirectionChange={(dir) => onDirectionChange(dir as 'over' | 'under')}
        />
      </div>

      <div className="parameter-group">
        <label>Threshold Digit</label>
        <DigitKeypad
          selectedDigit={thresholdDigit}
          onDigitSelect={onThresholdDigitSelect}
        />
        <div className="threshold-info">
          <div className="threshold-display">
            <span className="threshold-label">Over {thresholdDigit}:</span>
            <span className="threshold-digits">
              {Array.from({length: 9 - thresholdDigit}, (_, i) => thresholdDigit + i + 1).join(', ')}
            </span>
          </div>
        </div>
      </div>

      <div className="parameter-group">
        <label>Tick Count</label>
        <TickSelector
          tickCount={tickCount}
          onTickCountChange={onTickCountChange}
        />
      </div>
    </>
  );
};

export default OverUnderParams;
export { OverUnderParams };
